import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import useFilter from "../../../../../hook/useFilter"
import useVariable from "../../../../../hook/useVariable"

import Pagination from "./pagination"
import { favoriteActions } from "../../../../../store/favorite-slice"

const Filter = (props) => {

    let defaultfavoritecount = useSelector((state) => state.favorite.filterFavoriteCount)
    let pagination = useSelector((state) => state.favorite.pagination)

    let sliceFilters = useSelector(state => state.favorite.filter)
    let sliceActions = favoriteActions
    let sliceItems = useSelector(state => state.favorite.favorites)
    const [isMount, setIsMount] = useState(false)

    const { children } = props


    let dispatch = useDispatch()

    const { doFilter } = useFilter()
    const { variableValue } = useVariable()

    const [paginationItems, setPaginationItems] = useState([])

    useEffect(() => {
        let items = []
        if (pagination) {
            pagination.map((item, key) => {

                items.push(<Pagination key={key} favorites={item} index={key} />)
            })
        }

        setPaginationItems(items)
    }, [pagination])



    useEffect(() => {

        if (!isMount) {
            setIsMount(true)
            return
        }

        doFilter(sliceFilters, sliceItems, sliceActions)


    }, [sliceFilters])


    return <div className="p-3" >
        <div style={{ display: 'flex', justifyContent: 'space-between' }} >
            <div>
                <label>Pagination</label> <select name="filter-pagination" defaultValue={sliceFilters.pagination} className="mb-2" onChange={(event) => {
                    let value = variableValue(event.target.value)

                    dispatch(favoriteActions.setFilter({
                        key: 'pagination',
                        value
                    }))



                }} >
                    <option value='' >All</option>

                    {
                        defaultfavoritecount.map((item, key) => {

                            return <option key={key} value={item} >{item}</option>
                        })
                    }
                </select>

                <input type="text" name="filter-product_title-order_id" className="mb-2" defaultValue={sliceFilters.search} placeholder="order id or product title" onInput={(event) => {
                    let value = variableValue(event.target.value)


                    dispatch(favoriteActions.setFilter({
                        key: 'search',
                        value
                    }))


                }} />
            </div>

        </div>
        {children}
        <div className="pagination-container">{paginationItems}</div>
       
    </div>
}


export default Filter